module.exports = __webpack_public_path__ + "static/media/video.5534ac43.mp4";